export const PCP_SERVICE_LINE = 'Primary Care'
export const PCP_PEDIATRIC_SERVICE_LINE = 'Pediatric Primary Care'

export const PCP_SERVICE_LINE_NAMES = [
  PCP_SERVICE_LINE,
  PCP_PEDIATRIC_SERVICE_LINE,
]
